let passiveIfSupported_: null | boolean = null;

export const hasPassiveEventsSupport = (): boolean => {
  if (passiveIfSupported_ != null) {
    return passiveIfSupported_;
  }

  passiveIfSupported_ = false;

  try {
    // EventTarget's signature accepts a null listener, Window's overloads don't
    const eventTarget: EventTarget = window;
    eventTarget.addEventListener(
      'test',
      null,
      Object.defineProperty({}, 'passive', {
        get() {
          passiveIfSupported_ = true;
          return null;
        },
      }),
    );
  } catch {
    // do nothing
  }

  return passiveIfSupported_;
};
